import { HitsRelation } from './hits-relation';

export class TotalHits {
  value: number;

  relation: HitsRelation;
}
